// Response selectors:
export const getResData = (res) => res.data.data;
export const getResErrors = (res) => (res ? res.response.data.errors : null);

// Redux store selectors:
export const getBrand = (state) => state.initialProps.brand;
export const getUser = (state) => state.auth.user;

export const getLoggedIn = (state) => Boolean(getUser(state));

export const getUserId = (state) => state.initialProps.brand.userId;

export const getResetPWError = (state) => {
  if (state.auth.errors) {
    if (state.auth.errors.full_messages) {
      return state.auth.errors.full_messages[0];
    }
    return state.auth.errors[0];
  }
  return null;
};

export const getAuthError = (state) =>
  state.auth.errors && state.auth.errors[0];

export const getSubmitting = (state) => state.auth.submitting;
export const getNoticeText = (state) => state.auth.noticeText;
export const getTokenValidating = (state) => state.auth.tokenValidating;
export const getSessionTimeout = (state) => state.auth.sessionTimeout;

export const getSubmitSucceeded = (state) => state.auth.submitSucceeded;
